import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/sequence-quests', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/sequence-quests', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/sequence-quests', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/sequence-quests', {
      params,
    })
    return response
  },
  async get(params) {
    let response = await api.get('/admin/sequence-quests/detail', {
      params,
    })
    return response.data.data.document || null
  },
}
